/**
 * Proyecto: MOGOTAX
 * Módulo TAI - Diálogo de Confirmación de Eliminación
 * Fecha: 18 de Febrero 2026
 */

import React, { useState } from "react";
import { Modal, Typography, message, Alert } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import api from "../../../axiosConfig";

const { Text } = Typography;

const DeleteTransportadoraDialog = ({
  open,
  onClose,
  transportadora,
  fetchTransportadoras,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!transportadora?.id) return;

    setIsDeleting(true);
    try {
      await api.delete(`/transportadoras/${transportadora.id}`);
      message.success("Transportadora eliminada exitosamente");
      fetchTransportadoras();
      onClose();
    } catch (error) {
      console.error("Error al eliminar transportadora:", error);
      if (error.response?.data?.error) {
        message.error(error.response.data.error);
      } else {
        message.error("Error al eliminar la transportadora");
      }
    } finally {
      setIsDeleting(false);
    }
  };

  if (!transportadora) return null;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={handleDelete}
      okText="Eliminar"
      cancelText="Cancelar"
      okButtonProps={{
        danger: true,
        loading: isDeleting,
        icon: <DeleteOutlined />,
      }}
      title={
        <span>
          <ExclamationCircleOutlined
            style={{ color: "#faad14", marginRight: 8 }}
          />
          Confirmar Eliminación
        </span>
      }
    >
      <Alert
        message="Advertencia"
        description={
          <>
            <p>
              ¿Está seguro que desea eliminar la transportadora{" "}
              <Text strong>"{transportadora.nombre}"</Text>?
            </p>
            <p>
              Esta acción no se puede deshacer. Si la transportadora tiene
              traslados asignados, no podrá ser eliminada.
            </p>
          </>
        }
        type="warning"
        showIcon
      />
    </Modal>
  );
};

DeleteTransportadoraDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  transportadora: PropTypes.object,
  fetchTransportadoras: PropTypes.func.isRequired,
};

export default DeleteTransportadoraDialog;
